/**
 * Path helpers of the /me portal (#1768) with NO imports: main.tsx needs them
 * before `Sentry.init`, and this module must not pull date-fns or the date
 * helpers into the entry chunk ahead of Sentry. Re-exported by mePortal.ts.
 */

export const ME_BASE_PATH = '/me';

/** True for `/me` and anything below `/me/`; `/meals` or `/menu-activities` are not portal paths. */
export function isMePath(pathname: string): boolean {
  return pathname === ME_BASE_PATH || pathname.startsWith(`${ME_BASE_PATH}/`);
}

/** Sentry replay sample rates: replay is off on /me, unchanged elsewhere. */
export function meSentryReplayRates(
  pathname: string,
  appEnv: string | undefined,
): { session: number; onError: number } {
  const onMe = isMePath(pathname);
  return {
    session: appEnv === 'production' && !onMe ? 0.1 : 0,
    onError: onMe ? 0 : 1.0,
  };
}
